import { ISalesOrder } from 'v2/modules/order';

export enum InvoiceStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface ISalesOrderWithInvoicing extends ISalesOrder {
  invoicingStatus ?:InvoiceStatus;
  invoicingError ?:string;
  invoicingErrors ?:string[];
}
